var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('layout-header'),_c('main',{staticClass:"section-container-color",attrs:{"id":"content"}},[_c('router-view')],1),_c('layout-footer'),_c('layout-social-media')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }